import { ProcessedEvent } from '../../types'
import { EventItem } from './EventItem'
import { Stack } from '@pogokid/mui'

interface StackEventsProps {
  todayEvents: ProcessedEvent[]
}
export const StackEvents = ({
  todayEvents,
}: StackEventsProps) => {
  return (
    <Stack my={1} mx={0.5} spacing={0.5}>
      {todayEvents.map((event) => (
        <EventItem key={event.uid} event={event} showdate />
      ))}
    </Stack>
  )
}
